
import { defineComponent, ref, computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { WeveButtonIcon } from '@weve/ui'

import { useRoomService, useLastRooms } from '@/use'
import { HistoryIcon } from '@icons'
import { indexBy } from '@/util'

const fields = {
  id: true,
  name: true,
} as const

export default defineComponent({
  name: 'RecentlyViewedRooms',
  components: {
    WeveButtonIcon,
    HistoryIcon,
  },
  setup() {
    const { service } = useRoomService()
    const { lastRooms } = useLastRooms()
    const expanded = ref(false)

    const enabled = computed(() => lastRooms.value.length > 0)
    const { data, isLoading } = useQuery({
      queryKey: ['rooms', lastRooms.value, fields],
      queryFn: () => service.search({ id: lastRooms.value }, fields),
      enabled,
    })

    const rooms = computed(() => {
      if (data.value === undefined) return []
      const byId = indexBy(data.value, 'id')

      return lastRooms.value.reduce((acc, roomId) => {
        const room = byId.get(roomId)
        if (room !== undefined) {
          acc.push(room)
        }
        return acc
      }, [] as { id: number; name: string }[])
    })

    return {
      expanded,
      rooms,
      isLoading,
      enabled,
    }
  },
})
